// extracted by mini-css-extract-plugin
export default {"seminarsListItem":"HmMrjB4klc0lKOD0yI3I","svg":"Kt481ilF9gMvNIsaE9Jq","skillsTitle":"Sb1BeCVbaLcsG12Wfe0C","skillsContent":"nC3n_GMy0zMfdfhfHn4m"};